import React from 'react';
import {Grid} from '@material-ui/core';
import Aux from "../../../hoc/Auxilliary";
import DegreePlan from '../../../components/Students/DegreePlan';
const DegreePlanPage=()=>{
  return(
    <Aux>
    <Grid container>
      <Grid item container xs={12} sm={10} style={{ margin: "0 auto" }}>
        <DegreePlan/>
      </Grid>
    </Grid>
  </Aux>
  )
}

export default DegreePlanPage;